<template>
  <wo-region v-if="company">
    <wo-layout>
      <wo-title tag-name="h3" v-t="'admin.company.createTitle'" />
    </wo-layout>
    <company-edit :value="company" @input="confirm" @cancel="cancel" />
  </wo-region>
</template>

<script>

import { ADMIN_COMPANY } from '@/routes/admin'

import { Company } from '@/model/company'

import CompanyEdit from '@/components/admin/CompanyEdit'

export default {
  components: { CompanyEdit },
  data () {
    return {
      company: new Company()
    }
  },
  methods: {
    confirm (company) {
      this.$router.push({ name: ADMIN_COMPANY, params: { companyId: company.id } })
    },
    cancel () {
      this.$router.go(-1)
    }
  }
}
</script>
